import { render } from "./OrderExpenseCreatePage.vue?vue&type=template&id=33a9eda8"
import script from "./OrderExpenseCreatePage.vue?vue&type=script&lang=js"
export * from "./OrderExpenseCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__